import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { scrollToElement } from '../services/Scroll'
import { CMS } from '../core/config'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class Page extends Component {
    prepare() {
        if (CMS) {
            return
        }

        this.element.addEventListener('click', this.handleClick)

        EventBus.on('swup:aftercontentchange', this.getButtons)
        this.getButtons()
    }

    destroy() {
        EventBus.off('swup:aftercontentchange', this.getButtons)
    }

    getButtons = () => {
        this.octaButtons = Array.from(this.element.querySelectorAll('.ButtonOctagon'))

        if (this.octaButtons) {
            this.octaButtons.map($element => {
                $element.addEventListener('click', this.handleOctaButtonClick)
            })
        }
    }

    handleOctaButtonClick = event => {
        let target = event.target.closest('.ButtonOctagon')

        target.classList.add(STATES.ACTIVE)
        setTimeout(() => target.classList.remove(STATES.ACTIVE), 1000)
    }

    handleClick = event => {
        if (event.defaultPrevented) {
            return
        }

        const target = event.target.closest('a')

        if (!target) {
            return
        }

        const id = target.href.split('#')[1]

        if (!id) {
            return
        }

        const element = document.getElementById(id)

        console.log(element)

        if (!element) {
            return
        }

        event.preventDefault()

        let offset = (target.dataset.offset) ? target.dataset.offset : 0

        scrollToElement(element, { offset: offset })

    }

}